import OrderDTO from "@/dto/order/OrderDTO";
import { observer } from "mobx-react-lite";
import React from "react";

interface PendingPaymentCountInfoProps {
    order: OrderDTO;
}

export function shouldRenderPendingPaymentCountInfo(order: OrderDTO) {
    return order.sameBuyerPendingPaymentCount > 0;
}

/**
 * 在待发货订单列表:
 * 如果同一个买家有未付款订单，显示“此买家有 n 笔未付款订
 */
const PendingPaymentCountInfo: React.FC<PendingPaymentCountInfoProps> = function (props) {
    const { order } = props;

    if (shouldRenderPendingPaymentCountInfo(order)) {
        return (
            <div>
                <span className="text-warning small mt5">
                    此买家还有 {order.sameBuyerPendingPaymentCount} 笔未付款订单
                </span>
            </div>
        );
    }

    return null;
};

export default observer(PendingPaymentCountInfo);
